module.exports = __webpack_public_path__ + "static/img/environment.7c3d5ec3.svg";